import actionConsts from '../../constants/actions';

const defaultStrings = (state = [], action = {}) => {
    let { payload } = action
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return payload.defaultLabels;

        default:
            return state;
    }
};

export default defaultStrings;


// WEBPACK FOOTER //
// /src/reducers/uiState/defaultStrings.js